import * as R from 'ramda';
import { Suspense } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import AppHeader from 'components/App/Header';
import AppFooter from 'components/App/Footer';
import usePendo from 'hooks/usePendo';
import useCurrentUser from 'hooks/useCurrentUser';
import { Wrapper, AppBody } from './Styled';
import MasqueradeStatus from 'components/App/Masquerade';
import PageLoader from 'components/PageLoader/PageLoader';
import { AUTH_PATHS_REGEX, loginRedirectPath } from 'helpers/authPaths';
import i18n from 'helpers/i18n';
import messages from './messages';

export function App() {
  usePendo();
  const currentUser = useCurrentUser();
  const location = useLocation();

  const handleSkipToMainContent = () => {
    // Some browsers (e.g. Safari) don't move focus to the fragment target
    // on their own, so focus it explicitly to make the skip link functional
    // for keyboard users.
    document.getElementById('main-content')?.focus();
  };

  if (R.isNil(currentUser.id) && !R.test(AUTH_PATHS_REGEX, location.pathname)) {
    return <Navigate replace to={loginRedirectPath(location)} />;
  }

  if (
    !R.isNil(currentUser.id) &&
    R.test(/\/single_logout|\/all/, location.pathname)
  ) {
    return <Navigate replace to="/" />;
  }

  return (
    <Wrapper>
      <a
        href="#main-content"
        onClick={handleSkipToMainContent}
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-charcoal-500 focus:shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-ds-border-focus"
      >
        {i18n.ft(messages.skipToMainContent)}
      </a>
      <MasqueradeStatus />
      <AppHeader />
      <AppBody id="main-content" tabIndex={-1}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </AppBody>
      <AppFooter />
    </Wrapper>
  );
}

export default App;
